import firebase from "firebase/app";
export function firestore() {
  return firebase.firestore();
}
export function collection(path) {
  return firestore().collection(path);
}
export function doc(colPath, docId) {
  return collection(colPath).doc(docId);
}
